module.exports = __webpack_public_path__ + "static/media/gorra (10).ed6c8b71.png";